(function () {
  // Wait until page is ready
  document.addEventListener("DOMContentLoaded", function () {
    // Find the product form
    const form = document.querySelector('form[action^="/cart/add"]');
    if (!form) return;

    // Find the variant id input (Shopify uses name="id")
    const variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return;

    // Find the add to cart button
    const addBtn =
      form.querySelector('button[type="submit"]') ||
      form.querySelector('input[type="submit"]');

    if (!addBtn) return;

    // Small helper: show a message under the button
    function showMessage(text) {
      let msg = form.querySelector(".limit-one-message");
      if (!msg) {
        msg = document.createElement("div");
        msg.className = "limit-one-message";
        msg.style.marginTop = "10px";
        msg.style.fontSize = "14px";
        msg.style.lineHeight = "1.4";
        msg.style.opacity = "0.9";
        form.appendChild(msg);
      }
      msg.textContent = text;
    }

    // Disable button if current variant already in cart
    function enforceLimitForCurrentVariant() {
      const currentVariantId = variantInput.value;
      if (!currentVariantId) return;

      fetch("/cart.js")
        .then((res) => res.json())
        .then((cart) => {
          const alreadyInCart = cart.items.some(
            (item) => String(item.id) === String(currentVariantId)
          );

          if (alreadyInCart) {
            addBtn.disabled = true;
            addBtn.setAttribute("aria-disabled", "true");
            showMessage("Limit 1 per order. This item is already in your cart.");
          } else {
            addBtn.disabled = false;
            addBtn.removeAttribute("aria-disabled");
            // Optional: clear message if not in cart
            const msg = form.querySelector(".limit-one-message");
            if (msg) msg.textContent = "";
          }
        })
        .catch(() => {
          // If cart fetch fails, don't block purchase
          // (KOR still protects at cart/checkout)
        });
    }

    // Run once on page load
    enforceLimitForCurrentVariant();

    // Run again if the variant changes (dropdown / swatches)
    // This listens for changes anywhere in the form
    form.addEventListener("change", function () {
      // Wait a moment in case theme updates the variant input asynchronously
      setTimeout(enforceLimitForCurrentVariant, 150);
    });
  });
})();
